import {Component, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {Subscription} from 'rxjs/Subscription';
import {ClientsService} from '../../../../_services/clients.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ClientsContactsPersons} from '../../../../_interfaces/clients/clients-contacts-persons';
import {GeneralService} from '../../../../_services/general.service';
import {PreviousUrlService} from '../../../../_services/previous-url.service';
import {ServerResponse} from '../../../../_interfaces/server.response';
import {ApiService} from '../../../../_interceptors/api.service';
import {PageTitleService} from '../../../../_services/page-title.service';
import {environment} from '../../../../../environments/environment';
import {Client} from '../../../../_interfaces/clients/clients';

@Component({
	selector: 'app-clients-contact-persons-list',
	templateUrl: './clients-contacts-persons-list.component.html',
	styleUrls: ['./clients-contacts-persons-list.component.scss'],
	animations: [routeAnimation]
})

export class ClientsContactPersonsListComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	public totalItems: number = 0;
	private currentPage: number = 0;
	private searchString: string = '';
	public client_id: number = null;
	public isLoading: boolean = false;
	public keepLoading: boolean = false;

	public clientContactsPersons: ClientsContactsPersons[] = [];

	private _activatedRouteSubscription: Subscription = null;

	@Input() smallWidget: boolean = false;

	constructor(private clientsService: ClientsService,
				private generalService: GeneralService,
				private previousUrlService: PreviousUrlService,
				private apiService: ApiService,
				private activatedRoute: ActivatedRoute,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.apiService.connectionChanged.subscribe(online => {
			if (online && this.clientContactsPersons.length === 0) {
				this.currentPage = 0;
				this.getClientContactsPersons(false);
			}
		});

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.client_id = parseInt(params['client_id'], 10);

			if (this.smallWidget === false) {
				this.clientsService.getClient(this.client_id).then((client: Client) => {
					if (typeof client !== 'undefined') {
						this.pageTitleService.setTitle(client.company_name + ' | Bekijk contactpersonen | ' + environment.webappName);
						this.pageTitleService.setPageTitle(client.company_name);
					}
				});
			}

			this.previousUrlService.setPreviousUrlIfNull('/clients/' + this.client_id + '/view');

			this.getClientContactsPersons(false);
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}
	}

	getClientContactsPersons(append_data: boolean = true) {
		if (!this.isLoading || this.keepLoading) {
			this.isLoading = true;
			this.keepLoading = false;
			this.currentPage++;

			this.clientsService.getContactPersons(this.client_id, {
				start: (this.currentPage - 1) * (this.smallWidget ? this.generalService.itemsPerPageShort : this.generalService.itemsPerPage),
				length: (this.smallWidget ? this.generalService.itemsPerPageShort : this.generalService.itemsPerPage),
				'columns[0][search][value]': this.searchString
			}).then((data: ServerResponse) => {
				if (typeof data.recordsTotal !== 'undefined') {
					this.totalItems = data.recordsTotal;
				}
				if (append_data === true) {
					this.clientContactsPersons.push(...<ClientsContactsPersons[]>data.data);
				} else {
					this.clientContactsPersons = <ClientsContactsPersons[]>data.data;
				}
				this.isLoading = false;
			});
		}
	}

	deleteClientContactPerson(client_id: number, contact_person_id: number) {
		this.clientsService.deleteContactPerson(client_id, contact_person_id).then(status => {
			if (status === true) {
				let index = this.clientContactsPersons.findIndex(data => data.id === contact_person_id);

				if (index !== -1) {
					this.clientContactsPersons.splice(index, 1);
				}
			}
		});
	}

	search($event) {
		this.searchString = $event;
		this.currentPage = 0;
		this.getClientContactsPersons(false);
	}
}
